<template>
  <div>
    <LessonCollection :lid="lid" :unid="unid" :unit="unit" :exrtype="exrtype"></LessonCollection>
  </div>
</template>

<script>
import LessonCollection from './LessonCollection'
export default {
  name: 'LessonUnitPractise',
  components: { LessonCollection },
  props: {
    lid: Number,
    unid: Number,
    unit: Object,
    exrtype: Number
  },
  data () {
    return {
      activeNames: ['1']
    }
  }
}
</script>
